import {  EmptyObservable  } from '/druid/EmptyObservable';

export const empty = EmptyObservable.create;